import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { FlamingoAuthService } from '../service/flamingo-auth.service';

@Injectable({
    providedIn: 'root'
})
export class FlamingoAuthGuard implements CanActivate {
    private readonly authService = inject(FlamingoAuthService);
    private readonly router = inject(Router);

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        // Check if user is logged in and token is valid
        if (this.authService.isLogged() && this.authService.isTokenValid()) {
            return true;
        }

        // If token exists but is invalid, clear it
        if (this.authService.getToken() && !this.authService.isTokenValid()) {
            console.warn('[FlamingoAuthGuard] Token is invalid, clearing and redirecting to login');
            this.authService.logout();
        }

        // Redirect to login page with returnUrl
        return this.router.createUrlTree(['/auth'], {
            queryParams: { returnUrl: state.url }
        });
    }
}


